export const paths = {
    'ERP': '/services/erp-software-development-services',
    'Software Development': '/services/software-development-services',
    'CRM': '/services/crm-software-development-services',
    'BI Systems': '/solutions/bi-systems',
    'IT Consulting': '/services/strategic-it-consulting',
}
